import { callAPI, API_MESSAGES } from "@/store/utils/api";
import { API_GW_URL } from "@/config/api";

let timer;

const setTimer = (context, expiresIn) => {
  timer = setTimeout(() => {
    context.dispatch("autoLogout");
  }, expiresIn);
};

export default {
  async submitLoginCredentials(context, payload) {
    return context.dispatch("auth", payload);
  },

  async auth(context, { code }) {
    const url = `${API_GW_URL}/auth/auth`;
    const response = await callAPI(url, { code }, API_MESSAGES.API_FAIL);

    const expiresIn = 32400 * 1000;
    const expirationDate = new Date().getTime() + expiresIn;
    setTimer(context, expiresIn);

    const outToken = response[0]?.OUT_TOKEN;
    if (!outToken) throw new Error("Token inválido ou não encontrado.");

    context.commit("setUserSession", { app_token: outToken, expirationDate });
    await context.dispatch("UserDetailList");
    await context.dispatch("UserApplicationList");
  },

  async Manhoso(context, payload) {
    console.log("Payload recebido em Manhoso action:", payload);
    const url = `${API_GW_URL}/auth/manhoso`;
    const response = await callAPI(url, {manhoso:'manhoso'}, API_MESSAGES.API_FAIL);
    const expiresIn = 7200 * 1000;
    const expirationDate = new Date().getTime() + expiresIn;
    setTimer(context, expiresIn);
    const outToken = response[0]?.OUT_TOKEN;
    if (!outToken) throw new Error("Token inválido ou não encontrado.");
    context.commit("setUserSession", { app_token: outToken, expirationDate });
    await context.dispatch("UserDetailList");
    await context.dispatch("UserApplicationList");
  },

  async UserDetailList(context) {
    const url = `${API_GW_URL}/auth/getDetails`;
    const response = await callAPI(url, { appToken: context.getters.getUserSession.app_token });
    context.commit("setUserDetail", response[0]);
  },

  async UserApplicationList(context) {
    const url = `${API_GW_URL}/auth/getApplications`;
    const response = await callAPI(url, { appToken: context.getters.getUserSession.app_token });
    context.commit("setUserApplication", response);
  },

  tryLogin(context) {
    const expirationDate = context.getters.getUserSession.expirationDate;
    if (expirationDate) {
      const expiresIn = expirationDate - new Date().getTime();
      if (expiresIn < 0) {
        context.dispatch("autoLogout");
        return;
      }
      setTimer(context, expiresIn);
    }
  },

  async logout(context) {
    const url = `${API_GW_URL}/auth/doLogout`;
    await callAPI(url, {
      username: context.getters.getUserDetailList.usr_username,
      app_token: context.getters.getUserSession.app_token,
    });
    context.commit("setIsAuthorized", false);
    clearTimeout(timer);
    context.commit("setUserSession", { app_token: null, expirationDate: null });
    localStorage.clear();
  },

  autoLogout(context) {
    context.commit("setAutoLogout");
    context.dispatch("logout");
  },
};